import React from "react";
import WarningIcon from '@mui/icons-material/Warning';

export default function DevisionGuarantorCmp(props: any) {
    return (

        <div
            //className="image-container"//{props.chequeImage != undefined ? "image-container" : ""}
            id="division"
            style={{
                width: "100%",
                margin: props.margin ? props.margin : "auto",
                background: "#fff",
                marginTop: props.marginTop ? props.marginTop : "-2vh",
                paddingBottom: props.padding ? props.padding : "2vh",
                marginBottom: props.padding ? props.padding : "2vh",
                // props.color ? props.color :
            }}
        >
            {props.title != null || props.title != undefined ? (
                <span
                    className="colorTitle fontWeight textFont16 mbottom10 "
                    style={{
                        marginTop: "-10px",
                        marginRight: "30px",
                        background: props.color ? "transparent" : "#fff",
                        paddingRight: "5px",
                        paddingLeft: "5px",
                    }}
                >
                    {props.icon ? props.icon : ""} {props.title}
                </span>
            ) : (
                ""
            )}

            <div
                className="guarantorCardBorderTitle cardTabBorderShadow borderCOlor"
                style={{
                    backgroundColor: props.color ? props.color : "#fff",
                    margin: props.setMargin ? props.setMargin : "",
                }}
            >
                {props.child}
                {props.validateDate ?
                    <>
                        <div style={{ backgroundColor: "#FFF0E1", height: '5vh', alignItems: 'center', display: 'flex' }}>
                            <WarningIcon
                                style={{ color: "#EE9D01", marginLeft: "0.3vh", marginRight: '2vh' }}
                            />
                            <span style={{ color: "#EE9D01", fontSize: '14px' }}>تاریخ چک بزرگتر از تاریخ مورد نظر است.</span>
                        </div>
                    </> : ""

                }
            </div>
        </div>
    );
}
